import React from "react";
import { useLocation } from "react-router-dom";

class RouteBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main role="alert" className="min-h-screen bg-zinc-950 text-zinc-100 grid place-items-center p-6">
        <div className="max-w-md text-center">
          <h1 className="text-xl font-semibold">This page couldn’t load</h1>
          <p className="mt-2 text-sm text-zinc-400">Try loading the page again.</p>
          <button type="button" className="mt-5 rounded-md border border-white/15 px-4 py-2 text-sm hover:bg-white/5" onClick={() => this.setState({ failed: false })}>
            Try again
          </button>
        </div>
      </main>
    );
  }
}

export default function RouteErrorBoundary({ children }) {
  const location = useLocation();
  return <RouteBoundary key={location.pathname}>{children}</RouteBoundary>;
}